import React from 'react';
import { UtensilsCrossed, ChefHat, Sparkles } from 'lucide-react';
import { FadeInUp } from './ScrollAnimationWrapper';

const RestaurantMenu = ({ language = 'de' }) => {
  
  const translations = {
    de: {
      title: 'Restaurant Menü',
    },
    en: {
      title: 'Restaurant Menu',
    }
  };

  const t = translations[language];

  return (
    <section className="section-padding bg-gradient-to-b from-luxury-cream via-luxury-pearl/60 to-luxury-cream">
      <div className="container-custom">
        
        {/* Header - kompaktniji */}
        <FadeInUp threshold={0.1} className="text-center mb-8">
          <h2 className="text-4xl md:text-5xl font-display font-bold text-luxury-charcoal mb-4">
            {t.title}
          </h2>
          <div className="w-24 h-1 bg-luxury-gold mx-auto" />
        </FadeInUp>

        {/* Flip HTML5 Flipbook - ŠIRI KONTEJNER za desktop */}
        <FadeInUp delay={200} threshold={0.1}>
          <div className="relative rounded-2xl overflow-hidden shadow-xl border-2 border-luxury-gold bg-gradient-to-br from-luxury-cream via-luxury-pearl/40 to-luxury-cream p-3 md:p-4">
            
            {/* Desktop - širok kao ostali sadržaj */}
            <div 
              className="hidden md:block pointer-events-auto" 
              style={{
                position: 'relative',
                paddingTop: '75vh',
                width: '100%',
                height: 0,
                minHeight: '600px'
              }}
            >
              <iframe 
                style={{
                  position: 'absolute',
                  border: 'none',
                  width: '100%',
                  height: '100%',
                  left: 0,
                  top: 0,
                  pointerEvents: 'auto'
                }}
                src="https://online.fliphtml5.com/menurestoran/tokq/"
                seamless="seamless"
                scrolling="no"
                frameBorder="0"
                allowTransparency="true"
                allowFullScreen={true}
                title="Restaurant Menu Flipbook"
              />
            </div>

            {/* Mobile - manja vertikalna verzija */}
            <div 
              className="block md:hidden pointer-events-auto" 
              style={{
                position: 'relative',
                paddingTop: '133%',
                width: '100%',
                height: 0,
                minHeight: '500px'
              }}
            >
              <iframe 
                style={{
                  position: 'absolute',
                  border: 'none',
                  width: '100%',
                  height: '100%',
                  left: 0,
                  top: 0,
                  pointerEvents: 'auto'
                }}
                src="https://online.fliphtml5.com/menurestoran/tokq/"
                seamless="seamless"
                scrolling="no"
                frameBorder="0"
                allowTransparency="true"
                allowFullScreen={true}
                title="Restaurant Menu Flipbook"
              />
            </div>

          </div>
        </FadeInUp>

        {/* Dekorativni elementi */}
        <FadeInUp delay={400} threshold={0.1} className="mt-8 text-center">
          <div className="flex justify-center gap-4">
            <UtensilsCrossed className="text-luxury-gold animate-bounce" size={28} />
            <ChefHat className="text-luxury-gold animate-bounce delay-100" size={32} />
            <Sparkles className="text-luxury-gold animate-bounce delay-200" size={28} />
          </div>
        </FadeInUp>

      </div>
    </section>
  );
};

export default RestaurantMenu;
